import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { StoreService } from '../store.service';
import { Store } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductFaqExistGuard implements CanActivate {

  faqData: any;

  constructor(private svc: StoreService, private router: Router, private store: Store) { };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const store_id = localStorage.getItem('store_id') ?? "";
    const bearer = localStorage.getItem('bearer') ?? "";
    const store_url = localStorage.getItem('store_url') ?? "";

    let token = "";

    if (bearer.length > 0) {
      token = bearer.toString();
    }

    return new Promise((resolve, reject) => {
      this.svc.getProductFaqLists(token, store_id, 'ALL').toPromise().then((response) => {
          if(response['data'].length <= 0) {
            this.router.navigate(['dashboard/product-faq/create']);
            resolve(false);
          } else {
            localStorage.setItem('store_id',store_id);
            localStorage.setItem('store_url',store_url);
            resolve(true);
          }
      })
    });
  }
}